import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AventiorLogo2 from "../../assets/png/CPV-Auto-logo-Final.png";
import "./CAMHeader.scss";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as acts from "../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { action } from "../../constants/action";
import { Divider, SwipeableDrawer } from "@mui/material";
import SettingDrawer from "../SettingsDrawer/SettingsDrawer";
import auth from "../../config/auth";
import Label from "../Label/Label";
import { investigatorRoutes } from "../../routes/routeConstants";
import { format } from "date-fns";
import { getDefaultRouteForRole } from "../../config/permissions";
import { messages } from "../../constants/commonMessages";

export default function CAMHeader(props) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openSettingDrawer, setOpenSettingDrawer] = useState(false);
  const navigate = useNavigate();
  const userLogout = useSelector((state) => state?.auth?.userLogout);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (userLogout?.apiSuccess) {
      localStorage.clear();
      navigate("/");
      auth.logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogout]);

  const handleLogout = () => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/");
    } else {
      const showNotification = true;
      dispatch(acts.userLogout(showNotification));
    }

    setAnchorEl(null);
  };

  const handleHome = () => {
    const userRole = localStorage.getItem("userRole");
    if (userRole) {
      const defaultRoute = getDefaultRouteForRole(userRole);
      navigate(defaultRoute || `/${investigatorRoutes.taskStatus}`);
    }
  };

  const toggleDrawer = (value) => {
    setOpenSettingDrawer(value);
    setAnchorEl(null);
  };

  const userRole = localStorage.getItem("userRole");
  const userSubRoles = JSON.parse(localStorage.getItem("userSubRoles") || "[]");

  return (
    <>
      <Box
        className="cam-header"
        sx={{ display: "flex", flexGrow: 1, backgroundColor: "gray" }}
      >
        <AppBar position="fixed">
          <Toolbar className="toolBar">
            <img
              src={AventiorLogo2}
              className="logo"
              onClick={() => handleHome()}
              alt="AventiorLogo"
            />
            <div className="vertical"></div>
            <Typography variant="subtitle1" className="HeaderProjectName">
              {action?.LOGO}
            </Typography>

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                paddingRight: "15px",
                alignItems: "flex-end", // aligns content to the right
              }}
            >
              <Label
                text={localStorage?.userName || "N/A"}
                paddingRight={15}
                fontSize="14px"
                fontWeight="600"
              />
              {/* <Typography variant="caption" color="text.secondary">
                Last login:{" "}
                {isNaN(new Date(localStorage.last_login))
                  ? localStorage.last_login ?? "N/A"
                  : format(new Date(localStorage.last_login), "PPpp")}
              </Typography> */}

              <Label
                text={
                  userSubRoles.length > 0
                    ? `${userRole} (${userSubRoles.join(", ") === "reviewer" ? "Approver" : userSubRoles.join(", ")})`
                    : userRole || "N/A"
                }
                paddingRight={15}
                fontSize="12px"
                fontWeight="600"
              />
            </Box>

            <IconButton
              size="medium"
              edge="start"
              aria-label="menu"
              onClick={handleClick}
            >
              <MenuIcon
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                className="user-profile-icon"
              />
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              className="user-profile"
              onClose={(e) => handleCloseMenu(e)}
              MenuListProps={{
                "aria-labelledby": "demo-positioned-button",
              }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div className="menu-wrapper">
                <div className="menu-version-wrap">
                  <h3 className="menu-title">About</h3>
                  <div className="menu-details">
                    <p className="app-name">{messages.APP_VERSION}</p>
                    <p className="release-date">Released: Jun 2026</p>
                  </div>
                </div>
                <Divider
                  className="menu-divider"
                  variant="middle"
                  component="li"
                />

                <div className="support-version-wrap">
                  <h3 className="support-title">Need help? </h3>
                  <h3 className="support-title">Contact us at</h3>

                  <div className="support-details">
                    <p className="support-name">
                      <a
                        href="mailto:support@aventior.com"
                        className="support-link"
                      >
                        support@aventior.com
                      </a>
                    </p>
                  </div>
                </div>

                <Divider className="menu-divider" />
                <MenuItem onClick={() => toggleDrawer(true)} disabled>
                  {action.SETTINGS}
                </MenuItem>
                <MenuItem onClick={handleLogout}>{action.LOGOUT}</MenuItem>
              </div>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>

      <div>
        <React.Fragment key={"right"}>
          <SwipeableDrawer
            className="header-toggle"
            anchor={"right"}
            open={openSettingDrawer}
            onClose={(e) => toggleDrawer(false)}
            onOpen={(e) => toggleDrawer(true)}
          >
            <SettingDrawer onClose={() => toggleDrawer(false)} />
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  );
}
